<template>
  <div
    class="tm-row uk-flex uk-flex-wrap uk-flex-middle uk-visible-hover-inline"
    :class="{ 'uk-text-muted': !installed }">
    <!-- NAME -->
    <div class="uk-width-large-4-10 uk-width-medium-1-2 uk-width-small-1-2 uk-text-truncate">
      <span
        :title="installed && isOutdated
          ? 'The installed package is Outdated'
          : !isKnown && !server.offline
          ? 'This language has no started translations. Be the first one!'
          : false"
        data-uk-tooltip>
        <i
          class="uk-icon-justify"
          :class="{
            'uk-icon-check': installed && !isOutdated,
            'uk-icon-level-down': installed && isOutdated,
            'uk-icon-question': !isKnown && !server.offline,
            'uk-text-success': installed && !isOutdated,
            'uk-text-warning': installed && isOutdated,
          }">
        </i>
        {{ name }}
      </span>
    </div>
    <!-- STATS -->
    <div class="uk-width-large-2-10 uk-width-small-1-2 uk-text-center uk-hidden-medium tm-medium-right"
      :class="{
        'uk-text-success': completed >= 80,
        'uk-text-warning': completed >= 30 && completed < 80,
        'uk-text-danger': completed < 30
      }"
      title="Translation Progress"
      data-uk-tooltip="{ delay: 500 }"
      v-text="completed
        ? completed + '%'
        : ''">
    </div>
    <!-- BUTTONS -->
    <div class="uk-width-large-4-10 uk-width-medium-1-2 uk-flex uk-flex-inline uk-flex-right uk-hidden-small">
      <!-- uninstall -->
      <tm-button
        v-if="installed"
        class="uk-invisible uk-button-danger uk-margin-small-left"
        icon="trash-o"
        title="Uninstall"
        @click="uninstall(code, name)">
      </tm-button>
      <!-- contribute -->
      <tm-button
        class="uk-margin-small-left"
        :class="{
          'uk-button-primary': !isKnown ,
          'uk-invisible': isKnown
        }"
        icon="pencil"
        :title="'Contribute'"
        :href="url">
      </tm-button>
      <!-- download -->
      <tm-button
        v-if="isKnown"
        :disabled="server.offline"
        class="uk-invisible uk-margin-small-left"
        icon="download"
        :title="'Download'"
        @click="download(code)">
      </tm-button>
      <!-- install -->
      <tm-button
        v-if="isKnown"
        class="uk-margin-small-left"
        style="primary"
        :disabled="server.offline"
        icon="bolt"
        :icon="!isOutdated && installed ? 'retweet' : 'bolt'"
        :title="!isOutdated && installed ? 'Reinstall' : (installed ? 'Update' : 'Install')"
        @click="install(code)">
      </tm-button>
    </div>
    <!-- SEPARATOR -->
    <div class="uk-width-1-1 uk-margin-small-top"><hr></div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    completed: {
      type: Number,
      coerce: (value) => parseInt(value)
    },
    installed: {
      type: Boolean,
      default: false
    },
    installedVersion: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: [Number, Boolean],
      default: false
    },
    code: {
      type: String,
      required: true
    },
    download: {
      type: Function,
      required: true
    },
    install: {
      type: Function,
      required: true
    },
    uninstall: {
      type: Function,
      required: true
    },
    server: {
      type: Object,
      required: true
    }
  },
  computed: {
    url: function () {
      const base = 'https://www.transifex.com/joolanders/zoolanders'
      return this.isKnown
        ? `${base}/translate/#${this.code}`
        : base
    },
    isOutdated: function () {
      return this.installedVersion !== this.timestamp
    },
    isKnown: function () {
      return !this.server.offline && this.timestamp && this.completed
    }
  }
}
</script>

<style lang="less">
@import "../../../node_modules/uikit/src/less/core/variables.less";

@media (max-width: @breakpoint-mini-max) {
  /* Halves */
  .uk-width-small-1-2,
  .uk-width-medium-1-2 {
    width: 50%;
  }
}

@media (max-width: @breakpoint-medium-max) {
  .tm-medium-right {
    text-align: right !important;
  }
}
</style>



/** WEBPACK FOOTER **
 ** Language.vue?c5553998
 **/